import { Group } from './style'

type Props = {
  children: React.ReactNode
}

export const ButtonGroup = ({ children }: Props) => {
  return <Group>{children}</Group>
}
